import { useCallback, useEffect, useState } from 'react';
import { type CustomDashboard, listDashboards } from '../api';

/**
 * Loads the current user's custom dashboards. Data fetching lives here (not in
 * the view); the page consumes { dashboards, loading, error, refresh }.
 */
export const useCustomDashboards = () => {
  const [dashboards, setDashboards] = useState<CustomDashboard[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setDashboards(await listDashboards());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load dashboards');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { dashboards, loading, error, refresh };
};
